var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      staticClass: "vicon",
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        fill: "currentColor",
        viewBox: "0 0 16.6153846 18",
      },
    },
    [
      _c(
        "g",
        {
          attrs: {
            id: "Page-1",
            stroke: "none",
            "stroke-width": "1",
            "fill-rule": "evenodd",
          },
        },
        [
          _c(
            "g",
            {
              attrs: {
                id: "MacBook-Pro-13-Copy-4",
                transform: "translate(-665.500000, -247.500000)",
                "fill-rule": "nonzero",
              },
            },
            [
              _c(
                "g",
                {
                  attrs: {
                    id: "поиск",
                    transform: "translate(121.000000, 180.000000)",
                  },
                },
                [
                  _c(
                    "g",
                    {
                      attrs: {
                        id: "инпут",
                        transform: "translate(530.000000, 26.000000)",
                      },
                    },
                    [
                      _c(
                        "g",
                        {
                          attrs: {
                            id: "calendar-dots",
                            transform: "translate(14.500000, 41.500000)",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M15.2307692,1.38461538 L13.1538462,1.38461538 L13.1538462,0.692307692 C13.1538462,0.309956712 12.8438894,0 12.4615385,0 C12.0791875,0 11.7692308,0.309956712 11.7692308,0.692307692 L11.7692308,1.38461538 L4.84615385,1.38461538 L4.84615385,0.692307692 C4.84615385,0.309956712 4.53619713,0 4.15384615,0 C3.77149517,0 3.46153846,0.309956712 3.46153846,0.692307692 L3.46153846,1.38461538 L1.38461538,1.38461538 C0.619913423,1.38461538 0,2.00452881 0,2.76923077 L0,16.6153846 C0,17.3800866 0.619913423,18 1.38461538,18 L15.2307692,18 C15.9954712,18 16.6153846,17.3800866 16.6153846,16.6153846 L16.6153846,2.76923077 C16.6153846,2.00452881 15.9954712,1.38461538 15.2307692,1.38461538 Z M3.46153846,2.76923077 L3.46153846,3.46153846 C3.46153846,3.84388944 3.77149517,4.15384615 4.15384615,4.15384615 C4.53619713,4.15384615 4.84615385,3.84388944 4.84615385,3.46153846 L4.84615385,2.76923077 L11.7692308,2.76923077 L11.7692308,3.46153846 C11.7692308,3.84388944 12.0791875,4.15384615 12.4615385,4.15384615 C12.8438894,4.15384615 13.1538462,3.84388944 13.1538462,3.46153846 L13.1538462,2.76923077 L15.2307692,2.76923077 L15.2307692,5.53846154 L1.38461538,5.53846154 L1.38461538,2.76923077 L3.46153846,2.76923077 Z M15.2307692,16.6153846 L1.38461538,16.6153846 L1.38461538,6.92307692 L15.2307692,6.92307692 L15.2307692,16.6153846 Z M9.34615385,10.0384615 C9.34615385,10.611988 8.88121878,11.0769231 8.30769231,11.0769231 C7.73416584,11.0769231 7.26923077,10.611988 7.26923077,10.0384615 C7.26923077,9.46493507 7.73416584,9 8.30769231,9 C8.88121878,9 9.34615385,9.46493507 9.34615385,10.0384615 Z M13.1538462,10.0384615 C13.1538462,10.611988 12.6889111,11.0769231 12.1153846,11.0769231 C11.5418581,11.0769231 11.0769231,10.611988 11.0769231,10.0384615 C11.0769231,9.46493507 11.5418581,9 12.1153846,9 C12.6889111,9 13.1538462,9.46493507 13.1538462,10.0384615 Z M5.53846154,13.5 C5.53846154,14.0735265 5.07352647,14.5384615 4.5,14.5384615 C3.92647353,14.5384615 3.46153846,14.0735265 3.46153846,13.5 C3.46153846,12.9264735 3.92647353,12.4615385 4.5,12.4615385 C5.07352647,12.4615385 5.53846154,12.9264735 5.53846154,13.5 Z M9.34615385,13.5 C9.34615385,14.0735265 8.88121878,14.5384615 8.30769231,14.5384615 C7.73416584,14.5384615 7.26923077,14.0735265 7.26923077,13.5 C7.26923077,12.9264735 7.73416584,12.4615385 8.30769231,12.4615385 C8.88121878,12.4615385 9.34615385,12.9264735 9.34615385,13.5 Z M13.1538462,13.5 C13.1538462,14.0735265 12.6889111,14.5384615 12.1153846,14.5384615 C11.5418581,14.5384615 11.0769231,14.0735265 11.0769231,13.5 C11.0769231,12.9264735 11.5418581,12.4615385 12.1153846,12.4615385 C12.6889111,12.4615385 13.1538462,12.9264735 13.1538462,13.5 Z",
                              id: "Shape",
                            },
                          }),
                        ]
                      ),
                    ]
                  ),
                ]
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }